<div *ngIf="strategies$ | async"><!-- trigger loading strategies --></div>

<div class="sideBtnPanel">
  <button
    class="btn btn-primary"
    name="settings-btn"
    ng-class="{ 'btn-right-open': open }"
    (click)="openSettings()"
  >
    <i class="glyphicon glyphicon-cog"></i>&nbsp;&nbsp;&nbsp;Settings
  </button>
</div>

<div class="top-content-row row" *ngIf="viewModel$ | async as viewModel">
  <div class="col-md-12">
    <h1 class="heading">
      <span>Appointment Status</span>

      <div class="col-md-5 pull-right">
        <div class="pull-right">
          <button
            class="btn btn-sm btn-primary"
            style="
              width: 80px;
              font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
              font-size: 12px;
              margin-left: 30px;
            "
            id="refreshButton"
            (click)="
              getAppointments(
                fromDate,
                viewModel.dateAppointments.length,
                'refresh'
              )
            "
            [disabled]="viewModel.loading"
          >
            <span *ngIf="viewModel.loading">Refreshing...</span>
            <span *ngIf="!viewModel.loading">Refresh</span>
          </button>
        </div>
      </div>
    </h1>
  </div>
  <div>
    <ng-appointment-list
      [appointments]="viewModel.dateAppointments"
      [loading]="loading$ | async"
      [strategies]="strategies$ | async"
      [urlType]="'appointment'"
      [queryFilter]="queryFilter$ | async"
      [selectedRemoteAppointmentId]="selectedRemoteAppointmentId"
      [selectedAppointmentId]="selectedAppointmentId"
      [currentUser]="currentUser$ | async"
      [selectedDate]="fromDate"
      (loadDataOnScroll)="
        getMoreAppointmentsOnScroll(viewModel.dateAppointments.length)
      "
    ></ng-appointment-list>
  </div>
</div>
